import React from 'react';
import { Container, Eyebrow, Section } from './Section';
import { DoodleUnderline } from '../brand/Doodles';
import { DoodleScatter } from '../brand/DoodleScatter';
type PageHeaderProps = {
  eyebrow: string;
  title: string;
  intro?: string;
  /** Seed keeps each page's header scatter distinct. */
  seed?: string;
};
export function PageHeader({
  eyebrow,
  title,
  intro,
  seed
}: PageHeaderProps) {
  return <Section className="bcm-paper relative overflow-hidden py-14 sm:py-18" data-id="element-358" data-mp="tu7tbfvybh08">
      <DoodleScatter tone="paper" seed={seed ?? title} layout="leftColumn" data-id="element-359" data-mp="ys9d6317bkcr" />
      <Container className="relative z-10" data-id="element-360" data-mp="yq6dsse5sevd">
        <Eyebrow data-id="element-361" data-mp="13izijg9mnn7g">{eyebrow}</Eyebrow>
        <h1 className="mt-3 max-w-3xl font-display text-4xl font-extrabold leading-[1.05] tracking-tight text-brand-navy sm:text-6xl" data-id="element-362" data-mp="13k14wgw3fw4h">
          {title}
        </h1>
        <DoodleUnderline className="mt-3 h-3.5 w-40" color="var(--bcm-yellow)" data-id="element-363" data-mp="1digmnt98dt1b" />
        {intro ? <p className="mt-6 max-w-2xl font-sans text-[17px] leading-relaxed text-ink" data-id="element-364" data-mp="1hk25dv8g51jf">{intro}</p> : null}
      </Container>
    </Section>;
}